import { NumericTextBox, NumericTextBoxChangeEvent } from '@progress/kendo-react-inputs';
import MarkerText from '../../../../components/inputs/MarkerText';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store-hooks';
import { setSetting } from '../../../../state/slices/settings-slice';
import { useSearchContext } from '../../context/SettingsSearchContext';

export default function SettingsMapScreenshotSizeElement() {
    const dispatch = useAppDispatch();
    const context = useSearchContext();
    const width = nullIfZero(useAppSelector((x) => x.settings.mapImageWidth));
    const height = nullIfZero(useAppSelector((x) => x.settings.mapImageHeight));

    const widthChanged = (e: NumericTextBoxChangeEvent) => {
        dispatch(setSetting('mapImageWidth', e.value));
    };

    const heightChanged = (e: NumericTextBoxChangeEvent) => {
        dispatch(setSetting('mapImageHeight', e.value));
    };

    return (
        <div className="d-flex align-items-center px-3 justify-content-between">
            <div>
                <div><MarkerText highlight={context.term}>Size</MarkerText></div>
                <div className="secondary-text"><MarkerText highlight={context.term}>Defaults to map size</MarkerText></div>
            </div>
            <div className="d-flex gap-2" style={{ width: 300 }}>
                <NumericTextBox
                    placeholder="width"
                    format={'#px'}
                    min={1}
                    step={1}
                    value={width}
                    className="flex-grow-1"
                    onChange={widthChanged}
                />
                <NumericTextBox
                    placeholder="height"
                    format={'#px'}
                    min={1}
                    step={1}
                    value={height}
                    className="flex-grow-1"
                    onChange={heightChanged}
                />
            </div>
        </div>
    );
}

function nullIfZero(input: number | null) {
    return input === 0 ? null : input;
}
